<nb-card >
  <nb-card-body>

  <nb-tabset  (changeTab)="changeTab($event)" *ngIf="editUser === true">

    <nb-tab tabTitle="Geral" [active]="true" class="ngx-geral-chart">
      <div class="row">
        <ng-container *ngIf="userActivity">
          <div class="col-xxxl-4 col-md-4" *ngFor="let user of userActivity">
            <nb-card>
              <nb-card-body>
                <div class="user-container">
                  <div class="user-icon">
                    <nb-icon class="nb-person" status="control"></nb-icon>
                  </div>
                  <span class="user-info">{{user.count}} Usuários Nos Últimos {{user.days}} Dias</span>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </ng-container>
      </div>
      
      <div class="row">
        <div class="col-xxxl-12 col-md-12">
          <nb-card>
            <nb-card-header>
              Últimas Atividades
            </nb-card-header>
            <nb-card-body>
              <ng2-smart-table class="order-smart-table" [settings]="settings" [source]="source">
              </ng2-smart-table>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </nb-tab>

    <nb-tab tabTitle="Acessos" [lazyLoad]="true" class="ngx-geral-chart">
      <div class="row">
        <div class="col-xxxl-12 col-md-12">
          <nb-card>
            <nb-card-header>
              Usuários Não Logados ( {{ NaoLogados }} )
            </nb-card-header>
            <nb-card-body>
              <ng2-smart-table class="order-smart-table" [settings]="settingsUser" [source]="ListUser">
              </ng2-smart-table>
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      <div class="row">
        <div class="col-xxxl-12 col-md-12">
          <nb-card>
            <nb-card-header>
              Usuários Logados ( {{ JaLogados }} )
            </nb-card-header>
            <nb-card-body>
              <ng2-smart-table class="order-smart-table" [settings]="settingsUserLogados" [source]="ListUserLogados">
              </ng2-smart-table>
            </nb-card-body>
          </nb-card>
        </div>
      </div>
    </nb-tab>

  </nb-tabset>

</nb-card-body>
</nb-card>